import { Link } from 'react-router';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { memo } from 'react';

function FundingConsumerNameForm({
  fundingConsumerId,
  fundingConsumerFirstName,
  fundingConsumerLastName,
}) {
  return (
    <>
      <Col md={2} className="bo-same-line d-flex align-items-baseline">
        <Form.Label>Consumer Name:</Form.Label>
        <Link className="ms-2 bo-link" to={`/consumer/${fundingConsumerId}`}>
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
        </Link>
      </Col>
      <Col md={2} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="firstName"
          id="firstName"
          value={fundingConsumerFirstName || ''}
          readOnly
        />
      </Col>
      <Col md={2} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="lastName"
          id="lastName"
          value={fundingConsumerLastName || ''}
          readOnly
        />
      </Col>
    </>
  );
}

export default memo(FundingConsumerNameForm);
